<template>
  <div>
    <v-row
      class="mt-5"
    >
      <v-col
        sm="12"
        md="12"
        lg="12"
        xl="6"
      >
        <section>
          <line-chart
            type="bar"
            :raw-data="playerPerformance"
            :chart-value-keys="[ { key: 'RMSSD', label: 'RMSSD', type: 'bar' } ]"
            x-value="last_name"
            y-value-prefix="player_stats."
            :yaxis="[ { title: { text: 'RMSSD' }} ]"
            :xaxis="{
              labels: {
                rotate: -45
              },
              categories: playerPerformance.map(p => p.first_name + ' ' + p.last_name),
              tickPlacement: 'on'
            }"
          >
            <template v-slot:header>
              <v-card-title class="pa-6">
                <div class="subtitle-2 grey--text text--grey-100">
                  RMSSD
                </div>
              </v-card-title>
            </template>
          </line-chart>
        </section>
      </v-col>
      <v-col
        sm="12"
        md="12"
        lg="12"
        xl="6"
      >
        <section>
          <line-chart
            type="bar"
            :raw-data="playerPerformance"
            :chart-value-keys="[ { key: 'pNN50', label: 'pNN50', type: 'bar' } ]"
            x-value="last_name"
            y-value-prefix="player_stats."
            :yaxis="[ { title: { text: 'pNN50' }} ]"
            :xaxis="{
              labels: {
                rotate: -45
              },
              categories: playerPerformance.map(p => p.first_name + ' ' + p.last_name),
              tickPlacement: 'on'
            }"
          >
            <template v-slot:header>
              <v-card-title class="pa-6">
                <div class="subtitle-2 grey--text text--grey-100">
                  pNN50
                </div>
              </v-card-title>
            </template>
          </line-chart>
        </section>
      </v-col>
      <v-col
        sm="12"
        md="12"
        lg="12"
        xl="6"
      >
        <section>
          <line-chart
            type="bar"
            :raw-data="playerPerformance"
            :chart-value-keys="[ { key: 'SDNN', label: 'SDNN', type: 'bar' } ]"
            x-value="last_name"
            y-value-prefix="player_stats."
            :yaxis="[ { title: { text: 'SDNN' }} ]"
            :xaxis="{
              labels: {
                rotate: -45
              },
              categories: playerPerformance.map(p => p.first_name + ' ' + p.last_name),
              tickPlacement: 'on'
            }"
          >
            <template v-slot:header>
              <v-card-title class="pa-6">
                <div class="subtitle-2 grey--text text--grey-100">
                  SDNN
                </div>
              </v-card-title>
            </template>
          </line-chart>
        </section>
      </v-col>
    </v-row>
  </div>
</template>

<script>
import LineChart from '@/components/charts/LineChart'

export default {
  name: 'PerformanceRRGraphs',
  components: { LineChart },
  props: {
    playerPerformance: {
      type: Array,
      required: true
    }
  }
}
</script>

<style scoped>

</style>
